import React, { Component } from 'react';
import { PageHeader, PageTitle, PdfViewer } from '../../components/index.js';

export class TrainingMaterialsEnglish extends Component {
  render() {
    return (
      <div className="userpage">
        <div className="pdf-align-items pdf-page-bottom-align">
        <PageTitle title="Training Materials" />
          <PageHeader title="Training Materials">
            <div className="user-page">
              <i className="fas fa-graduation-cap"></i>
            </div>
          </PageHeader>
          <div id="english"></div>
          <PdfViewer fileName="../trainingMaterials/EN-RSL_Training_CoreConcepts_2026_0416a.pdf" containerId="english" />
        </div>
      </div>
    );
  }

}
export default TrainingMaterialsEnglish;